export const classes = {
  editable: {
    minHeight: "100px !important",
    padding: "1px 10px",
    border: "1px solid #b5b5b5",
    borderTop: 0,
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",
  },

  editableError: {
    minHeight: "100px !important",
    padding: "1px 10px",
    border: `1px solid error.main`,
    borderTop: 0,
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",
  },

  toolbar: {
    display: "flex",
    gridGap: "10px",
    alignItems: "center",

    padding: 1,
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",

    backgroundColor: "primary.main",
    overflowX: "auto",
  },

  toolbarError: {
    display: "flex",
    gridGap: "10px",
    alignItems: "center",
    border: `1px solid error.main`,
    borderBottom: 0,

    padding: 1,
    borderTopLeftRadius: "4px",
    borderTopRightRadius: "4px",

    backgroundColor: "primary.main",
    overflowX: "auto",
  },

  icon: {
    color: "primary.contrastText",
  },

  button: {
    padding: "6px 8px",
    minWidth: 0,
    margin: "0 1px",
  },

  divider: {
    borderLeft: "1px solid #ffff",
    height: "22px",
  },

  colorButton: {
    borderRadius: 0,
    height: "25px",
  },

  boxColor: {
    display: "flex",
    flexFlow: "wrap column",
    maxHeight: "200px",
    width: "150px",
    overflow: "hidden",
    borderRadius: "3px",
  },

  boxLink: {
    padding: "10px",
    width: "350px",
  },
};
